
const uAgent = navigator.userAgent.toLowerCase()
function inAgent(str) {
  return uAgent.indexOf(str) !== -1
}

export const isWindows = inAgent('windows')
export const isIPhone = !isWindows && inAgent('iphone')
export const isIPod = inAgent('ipod')
export const isIPad = inAgent('ipad')
export const isIOS = isIPhone || isIPod || isIPad
// Google Search App (for IOS)
export const isGSA = inAgent('gsa') && isIOS
export const isIE = /msie|trident/.test(uAgent)
export const isEdge = inAgent('edge/')
export const isAndroid = inAgent('android')

export let hasPassiveEvents = false
if (typeof window !== 'undefined') {
  const passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true
      return undefined
    }
  } as any
  window.addEventListener('testPassive', null, passiveTestOptions)
  window.removeEventListener('testPassive', null, passiveTestOptions)
}

  /**
   * Returns whether or not device is mobile for responsive:
   */
function isMobileDevice() {
  // ipads aren't mobile
  if (isIPad) {
    return false
  }

  // smaller than 736 is mobile
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height
  if (screenWidth <= 736) {
    return true
  } else if (screenWidth <= 1280 && Math.abs(window.orientation as number) === 90) {
    // Android landscape:
    return true
  } else if (screenWidth === 1080 && screenHeight === 1920 && window.orientation === 0) {
    // Galaxy S4 portrait:
    return true
  } else if (screenWidth === 1920 && screenHeight === 1080
    && Math.abs(window.orientation as number) === 90) {
    // Galaxy S4 landscape:
    return true
  }

  return false
}

function viewportHeight() {
  return document.documentElement.clientHeight || window.innerHeight
}

function viewportWidth() {
  return document.documentElement.clientWidth || window.innerWidth
}

export default { isMobileDevice, viewportHeight, viewportWidth }
